// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import VueResource from 'vue-resource'
import App from './App'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/css/custom.css'
import './assets/css/style.css'
import './assets/css/header.css'
import './assets/css/footer.css'
import Toastr from 'vue-toastr'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import pt from 'vee-validate/dist/locale/pt_BR'
import VeeValidate, { Validator } from 'vee-validate'
import ValidatorEquals from '@/validators/equals'
import vueUpload from '@websanova/vue-upload'
import money from 'v-money'
import data from '../env.json'
import Datetime from 'vue-datetime'
import VueSelect from 'vue-select'
import axios from 'axios'
import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

Chart.plugins.unregister(ChartDataLabels)

// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import 'vue-select/dist/vue-select.css'

// font awesome 5
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAddressCard,
  faBalanceScale,
  faCalendar,
  faCalendarAlt,
  faCalendarCheck,
  faCalendarTimes,
  faCheckCircle,
  faClipboardList,
  faCross,
  faCube,
  faEdit,
  faEraser,
  faFileAlt,
  faFilter,
  faHandHoldingHeart,
  faList,
  faMoneyBill,
  faTachometerAlt,
  faTags,
  faThLarge,
  faPencilAlt,
  faPrint,
  faPlus,
  faRemoveFormat,
  faSave,
  faSearch,
  faSitemap,
  faSpinner,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faFileDownload,
  faExclamationTriangle,
  faUsers,
  faChartLine,
  faUserCheck,
  faCheck,
  faCheckDouble,
  faBullhorn,
  faUserTimes,
  faSquare,
  faCheckSquare,
  faUpload,
  faMinusCircle,
  faFileExport,
  faIdCard,
  faComment,
  faEnvelope,
  faMonument,
  faUser,
  faExternalLinkAlt,
  faSortNumericUpAlt,
  faMinus,
  faTrash,
  faListOl,
  faCaretDown,
  faArrowAltCircleRight,
  faLongArrowAltLeft,
  faChartBar,
  faPenSquare,
  faPaperPlane,
  faColumns,
  faCircle,
  faFilePdf,
  faFileCsv,
  faFileExcel,
  faDownload,
  faArrowLeft,
  faArrowUp,
  faSignOutAlt,
  faUserTag,
  faGavel,
  faUserTie,
  faClock,
  faFileImport,
  faUndo,
  faChevronLeft,
  faChevronRight,
  faLandmark,
  faMoneyCheckAlt,
  faSyncAlt,
  faSignature,
  faExchangeAlt,
  faStar,
  faFlagCheckered,
  faRunning,
  faInfo,
  faMapMarkerAlt,
  faListAlt,
  faArrowRight,
  faUserEdit,
  faBan,
  faHourglassStart,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faEye,
  faFont,
  faAdjust,
  faArrowsAltV,
  faArrowsAltH,
  faAlignJustify,
  faWrench,
  faFolder,
  faFolderOpen
} from '@fortawesome/free-solid-svg-icons'

// importação de icons regulares
import {
  faStar as farStar,
  faCalendarAlt as farCalendarAlt
} from '@fortawesome/free-regular-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faAddressCard,
  faBalanceScale,
  faCalendar,
  faCalendarAlt,
  faCalendarCheck,
  faCalendarTimes,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faClipboardList,
  faCross,
  faCube,
  faEdit,
  faEraser,
  faExclamationTriangle,
  faFileAlt,
  faFileDownload,
  faFileExport,
  faFilter,
  faHandHoldingHeart,
  faList,
  faMoneyBill,
  faTachometerAlt,
  faTags,
  faThLarge,
  faPencilAlt,
  faPrint,
  faPlus,
  faRemoveFormat,
  faSave,
  faSearch,
  faSitemap,
  faSpinner,
  faTimes,
  faTimesCircle,
  faUsers,
  faTrashAlt,
  faChartLine,
  faUserCheck,
  faBullhorn,
  faUserTimes,
  faSquare,
  faCheckSquare,
  faUpload,
  faMinusCircle,
  faIdCard,
  faComment,
  faEnvelope,
  faMonument,
  faUser,
  faExternalLinkAlt,
  faSortNumericUpAlt,
  faMinus,
  faTrash,
  faListOl,
  faCaretDown,
  faArrowAltCircleRight,
  faLongArrowAltLeft,
  faArrowUp,
  faChartBar,
  faPenSquare,
  faPaperPlane,
  faColumns,
  faCircle,
  faFilePdf,
  faFileCsv,
  faFileExcel,
  faDownload,
  faArrowLeft,
  faSignOutAlt,
  faUserTag,
  faGavel,
  faUserTie,
  faClock,
  faFileImport,
  faUndo,
  faChevronLeft,
  faChevronRight,
  faLandmark,
  faMoneyCheckAlt,
  faSyncAlt,
  faSignature,
  faExchangeAlt,
  faStar,
  farStar,
  faFlagCheckered,
  faRunning,
  faInfo,
  farCalendarAlt,
  faMapMarkerAlt,
  faListAlt,
  faArrowRight,
  faUserEdit,
  faBan,
  faHourglassStart,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faEye,
  faFont,
  faAdjust,
  faArrowsAltV,
  faArrowsAltH,
  faAlignJustify,
  faWrench,
  faFolder,
  faFolderOpen
)

/**
 * Início das importações das bibliotecas do leaftlet
 */
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'

Vue.component('l-map', LMap)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('l-marker', LMarker)

import { Icon } from 'leaflet'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

/**
 * Fim das importações do leaflet
 */

/**
 * Configuração do Analytics
 */

import VueAnalytics from 'vue-gtag'
import adminRoutes from '../src/router/admin'

if (process.env.NODE_ENV === 'production') {
  const excludedRoutes = adminRoutes[0].children.map(route => {
    return route.path === '/' ? '/admin' : `/admin/${route.path}`
  })

  Vue.use(
    VueAnalytics,
    {
      pageTrackerExcludedRoutes: excludedRoutes,
      config: { id: 'G-FK0KE8705Z' }
    },
    router
  )
}

/**
 * Fim do Analytics
 */

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Datetime)

window.jQuery = require('jquery') // << import jquery global
require('bootstrap')
require('vue-toastr/src/vue-toastr.less')

// Vue.use(VueResource)
Vue.use(Toastr)
Vue.use(vueUpload)
Vue.use(money)
Vue.use(VeeValidate, {
  fieldsBagName: 'formFields',
  dictionary: {
    pt_BR: {
      custom: {
        text: {
          required: 'O campo é obrigatório!'
        },
        password: {
          required: 'O campo é obrigatório!'
        },
        confirmarSenha: {
          required: 'O campo é obrigatório!'
        }
      }
    }
  }
})

Vue.component('pulse-loader', PulseLoader)
Vue.component('v-select', VueSelect)

Validator.extend('equals', ValidatorEquals)
Validator.localize('pt_BR', pt)

Vue.config.productionTip = false

axios.defaults.baseURL = data.apiUrl

axios.interceptors.response.use(
  response => {
    // Do something with response data
    return response
  },
  error => {
    // Do something with response error
    // You can even test for a response code
    // and try a new request before rejecting the promise
    if (error.response.status === 401) {
      if (!store.state.initialized) {
        store.commit('LOGOUT_USER')
        return router.push({
          name: 'Login',
          params: { errorMsg: 'Sessão Expirada!' }
        })
      } else {
        router.app.$toastr.e('Seu token expirou faça o login novamente!')
        router.app.$refs.loginModal.show()
        //store.commit('LOGOUT_USER')
      }
    }

    return Promise.reject(error)
  }
)

Vue.prototype.$http = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  data,
  template: '<div><App/></div>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js